import React from 'react'
import KenTable from '../../../components/KenTable'
import { Box, Typography } from '@mui/material';

const UpcomingSchedule = () => {
    const columns = [
        { field: "name", headerName: "Course name" },
        { field: "code", headerName: "Course code" },
        { field: "exam", headerName: "Semester" },
        { field: "credits", headerName: "Credits" },
        { field: "format", headerName: "Format" },
        { field: "type", headerName: "Type" },
        { field: "date", headerName: "Date" },
        {
            field: "startTime",
            headerName: "Time",
            renderCell: ({ row }: any) => row?.startTime || row?.time || "--",
        },

    ];
    const rows = [
        { id: 1, name: "Network Analysis & Synthesis", code: "ECE101", exam: "End Semester", credits: 3, format: 79, type: "Regular", date: "13-08-2025", startTime: "09:00 AM" },
        { id: 2, name: "Network Analysis & Synthesis", code: "ECE101", exam: "End Semester", credits: 3, format: 79, type: "Regular", date: "13-08-2025", startTime: "09:00 AM" },
        { id: 3, name: "Network Analysis & Synthesis", code: "ECE101", exam: "End Semester", credits: 3, format: 79, type: "Regular", date: "13-08-2025", startTime: "09:00 AM" },
        { id: 4, name: "Network Analysis & Synthesis", code: "ECE101", exam: "End Semester", credits: 3, format: 79, type: "Regular", date: "13-08-2025", startTime: "09:00 AM" },

    ];
    return (
        <div className='p-4'>
            <Typography className='fw-bold'>Semester I</Typography>
            <Box className='mt-4'>
            <KenTable columns={columns} rows={rows} />

            </Box>

        </div>
    )
}

export default UpcomingSchedule

